import { type AppState } from 'src/core/reducers';

export const getBudget = (state: AppState) => state.layout.budget;

export const getDisplayMode = (state: AppState) => state.layout.displayMode;
